export interface DashboardAppBarProps {
  height: number;
  isPinned?: boolean;
  sidebarFullWidth: number;
  sidebarWidth: number;
}

export const dashboardAppBarStyles = ({ height, isPinned, sidebarFullWidth, sidebarWidth }: DashboardAppBarProps): Record<string, any> => ({
  display: 'none',
  height,
  left: isPinned ? sidebarFullWidth : sidebarWidth,
  width: 'unset',

  '@media(min-width: 600px)': {
    display: 'flex',
  },
});
